export function isSupplierPortalPath(pathname = '') {
  if (typeof pathname !== 'string') return false;
  return pathname === '/supplier' || pathname.startsWith('/supplier/');
}
